import { EventEmitter } from 'eventemitter3';
export class FrameExtractor {
    track;
    consumer;
    trackProcessor;
    abortController = new AbortController();
    stopped = false;
    emitter = new EventEmitter();
    constructor(track) {
        this.track = track;
        this.consumer = new WritableStream({
            write: (frame) => {
                this.emitter.emit('frame', frame);
            },
        });
    }
    start = () => {
        if (!this.track) {
            throw new Error('Track is not set');
        }
        if (!this.consumer) {
            throw new Error('Consumer is not set');
        }
        this.trackProcessor = new MediaStreamTrackProcessor({
            track: this.track,
            // maxBufferSize needs to be atleast 1 for the
            // MediaStreamTrackProcessor to work in Safari
            // when screen sharing is enabled
            maxBufferSize: 1,
        });
        this.trackProcessor.readable
            .pipeTo(this.consumer, {
            signal: this.abortController.signal,
        })
            .catch((_e) => {
            //console.log('FrameExtractor canceled in pipeTo');
        })
            .finally(() => {
            this.stopped = true;
            this.emitter.emit('aborted');
        });
    };
    stop = () => {
        if (this.stopped) {
            return Promise.resolve();
        }
        return new Promise((resolve) => {
            this.abortController.abort('Aborted');
            this.emitter.once('aborted', () => {
                resolve();
            });
        });
    };
}
